import { render, staticRenderFns } from "./FormReasignacion.vue?vue&type=template&id=9bc9a350&scoped=true&"
import script from "./FormReasignacion.vue?vue&type=script&lang=js&"
export * from "./FormReasignacion.vue?vue&type=script&lang=js&"
import style0 from "./FormReasignacion.vue?vue&type=style&index=0&id=9bc9a350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc9a350",
  null
  
)

export default component.exports